import Vue from "vue";
import Router from "vue-router";
import MainPage from "../pages/MainPage.vue";
import AboutPage from "@/pages/AboutPage.vue";
import NthNationalAssemblyPage from "@/pages/NthNationalAssemblyPage.vue";
import CongressmanBillPage from "@/pages/CongressmanBillPage.vue";
import StandingCommitteeBill from "@/pages/StandingCommitteeBill.vue";

Vue.use(Router);

const routes = [
  { path: "/", component: MainPage },
  { path: "/about", component: AboutPage },
  { path: "/nth-national-assembly", component: NthNationalAssemblyPage },
  { path: "/congressman-bill", component: CongressmanBillPage },
  { path: "/standing-committee-bill", component: StandingCommitteeBill },
];

const router = new Router({
  scrollBehavior() {
    return new Promise((resolve) => {
      resolve({ x: 0, y: 0 });
    });
  },
  routes,
});

export default router;
